import useCanAmendOrder from "./useCanAmendOrder";
import useCanCancelOrder from "./useCanCancelOrder";
import useCanSaveOrder from "./useCanSaveOrder";
import useCanSubmitOrder from "./useCanSubmitOrder";
import useOrderIsBeforeCutoff from "./useOrderIsBeforeCutoff";
import useValidAgainstProductRelatedGroups from "./useValidAgainstProductRelatedGroups";

const useOrderValidation = () => {
  const canBeSubmitted = useCanSubmitOrder();
  const canBeAmended = useCanAmendOrder();
  const canBeSaved = useCanSaveOrder();
  const canBeCancelled = useCanCancelOrder();
  const isBeforeCutoff = useOrderIsBeforeCutoff();
  const validAgainstProductRelatedGroups = useValidAgainstProductRelatedGroups();

  return {
    canAmendOrder: canBeAmended,
    canSubmitOrder: canBeSubmitted,
    canSaveOrder: canBeSaved,
    canCancelOrder: canBeCancelled,
    isBeforeCutoff,
    validAgainstProductRelatedGroups
  };
};

export default useOrderValidation;
